import { useCallback, useContext, useEffect, useReducer } from 'react'
import { useTranslation } from 'react-i18next'
import useNotifications from '../../../hooks/useNotifications'
import { getUserGroups } from '../../../services/userService'
import { deepCopy } from '../../../util/Utils'
import { UserContext } from '../UserContext'

// Constants
const actions = {
  REFRESH_USER_GROUPS_DATA_AND_CONTROLS: 'REFRESH_USER_GROUPS_DATA_AND_CONTROLS',
  SET_CHECKED_GROUPS: 'SET_CHECKED_GROUPS',
  SET_USER_GROUP_DATA: 'SET_USER_GROUP_DATA',
}

function userGroupsReducer(oldState, action) {
  const newState = deepCopy(oldState)
  const { payload, type } = action

  switch (type) {
    case actions.REFRESH_USER_GROUPS_DATA_AND_CONTROLS: {
      newState.memberSummaries = null
      newState.selectedGroups = []
      newState.refreshData = !newState.refreshData
      break
    }
    case actions.SET_USER_GROUP_DATA: {
      newState.memberSummaries = payload.memberSummaries
      break
    }
    case actions.SET_CHECKED_GROUPS: {
      newState.selectedGroups = newState.memberSummaries.filter((memberSummary) => payload.includes(memberSummary.id))
      break
    }
    default:
      break
  }
  return newState
}

export default function useGroupReservations() {
  const { t } = useTranslation()
  const { error } = useNotifications()
  const { currentUser } = useContext(UserContext)

  // Initial State
  const initialState = {
    // controls
    refreshData: false,
    selectedGroups: [],
    // data
    memberSummaries: null,
  }
  // Reducer Hook
  const [userGroupsState, userGroupsDispatch] = useReducer(userGroupsReducer, initialState)
  // Effects
  useEffect(() => {
    let isCurrent = true
    if (currentUser.dmcUser.cisId) {
      getUserGroups(currentUser.dmcUser.cisId, currentUser.contributorId)
        .then((response) => {
          if (isCurrent) {
            userGroupsDispatch({ type: actions.SET_USER_GROUP_DATA, payload: response.data })
            userGroupsDispatch({ type: actions.SET_CHECKED_GROUPS, payload: [] })
          }
        })
        .catch((err) => {
          error(
            t('user.errors.retrievingUserGroups', {
              defaultValue: `Error retrieving user groups: ${err.message || ''}`,
              message: err.message || '',
            }),
            err
          )
        })
    }
    return () => {
      isCurrent = false
    }
  }, [currentUser.contributorId, currentUser.dmcUser.cisId, error, userGroupsState.refreshData, t])
  // Functions
  const setCheckedGroups = useCallback(
    (checkedItems) => {
      if (userGroupsState.selectedGroups.length !== checkedItems.length) {
        userGroupsDispatch({ type: actions.SET_CHECKED_GROUPS, payload: checkedItems })
      }
    },
    [userGroupsState.selectedGroups.length]
  )
  const refreshUserGroupsDataAndControls = () => {
    userGroupsDispatch({ type: actions.REFRESH_USER_GROUPS_DATA_AND_CONTROLS })
  }
  // Variables
  // Helpers
  const helpers = {
    refreshUserGroupsDataAndControls,
    setCheckedGroups,
  }
  return [userGroupsState, helpers]
}
